<template>
<HomeAltLayout isHome="true" bg_icon='fyiio'>
  <div class="row alert alert-danger" v-if="error">
      <div class="input-field col s6"></div>
      <div v-if="error" class="error s2">{{ error.message }}</div>
      <div v-else><br><br><br></div>
      <div class="input-field col s4"></div>
  </div>
  <FyiioSvgLogo />
  <br>
  
  <div class="row register-form smallzer">
    <div class="center col s12 m8 offset-m2">
      <div style="color:white;font-size:36px;font-weight:400;padding: 15px 5px 25px 25px !important" class="valign">We've moved to a new platform!</div>
    </div>
  </div>
  <br>
  
  <div class="row register-form">
    <div class="center col s10 offset-s1 m6 offset-m3" style="background-color:white;border-radius:5px;padding:25px;">
      <p style="font-size:16px;">Hey there! We've been busy making fyiio even better. To sign up for a new account, head over to <a href="https://fyi.io" target="_blank">fyi.io</a>.</p>
      <p style="font-size:16px;font-style:italic;color:#666;">Don't worry, it's the same great tutorials with a fresh new look. We think you'll love it.</p>
      <a href="https://fyi.io" target="_blank" class="btn" style="margin:15px 0;width:auto;padding:0 20px;height:40px;line-height:40px;border-radius:20px;text-transform:unset;background-color:#00B8D4;color:black;font-weight:600;letter-spacing:0.5px;">Take me to the new platform</a>
    </div>
  </div>
  <br>
  
  <div class="row register-form smallzer">
    <div class="col s12 m6 offset-m3 center">
      <span style="color:white;font-size:16px;">Already have an account on this platform?
        <a href="/login" style="color:#27aae1">Log in here</a>
      </span>
    </div>
  </div>

  <!-- Keeping the modals but they're not needed in the new design -->
  <div id="pmodal" class="modal">
    <!-- Privacy policy content - kept unchanged -->
    <div class="modal-content left-align">
      <!-- Original content kept -->
    </div>
    <div class="modal-footer">
      <a class="modal-close waves-effect waves-green btn-flat">Close</a>
    </div>
  </div>
  
  <div id="tosmodal" class="modal">
    <!-- Terms of service content - kept unchanged -->
    <div class="modal-content left-align">
      <!-- Original content kept -->
    </div>
    <div class="modal-footer">
      <a class="modal-close waves-effect waves-green btn-flat">Close</a>
    </div>
  </div>
</HomeAltLayout>
</template>

<script>
setTimeout(() => {
  M.updateTextFields();
}, 2000)

import HomeAltLayout from '@/containers/layouts/HomeAltLayout'
import MobileLayout from '@/containers/layouts/MobileLayout'
import FyiioSvgLogo from '@/components/FyiioSvgLogo'

export default {
  data () {
    return {
      error: null
    }
  },
  components: {
    HomeAltLayout, MobileLayout, FyiioSvgLogo
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}
.btn {
  text-decoration: none;
}
a {
  color: #27aae1;
  text-decoration: underline;
}
.btn.blue:hover {
  background-color: #1976d2 !important;
}
</style>


// WEBPACK FOOTER //
// src/containers/HomeAlt.vue